var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSteam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 43.3334C33.6328 43.3334 43.3333 33.6329 43.3333 21.6667C43.3333 9.70056 33.6328 0 21.6667 0C9.7005 0 0 9.70056 0 21.6667C0 33.6329 9.7005 43.3334 21.6667 43.3334Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4682 21.302L33.2482 20.847L35.3177 13.5288L29.2608 8.71672L21.8167 15.0357L24.4682 21.302Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2798 21.661L33.5833 20.5835L35.7246 17.3589L31.3913 13.0256L26.0298 18.411L29.2798 21.661Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5841 10.1078C35.9742 11.5658 36.8333 13.535 36.8333 15.7085C36.8333 20.1958 33.1956 23.8335 28.7083 23.8335C28.4879 23.8319 28.2677 23.8213 28.0482 23.8018L21.6603 29.3391C21.6513 30.1403 21.4942 30.933 21.1969 31.6771C19.8567 35.0077 16.0702 36.621 12.7397 35.2805C12.4766 35.1746 12.2297 35.0473 11.9886 34.9123C11.9417 34.8859 11.8952 34.8595 11.849 34.8319C11.6199 34.6961 11.4001 34.5496 11.193 34.3897C11.1862 34.3844 11.1787 34.3802 11.1719 34.3749L11.1592 34.377L20.0353 43.2531C20.5779 43.3004 21.1221 43.3272 21.6667 43.3335C22.1403 43.3321 22.6139 43.3152 23.0864 43.2828C23.1586 43.2781 23.2303 43.2712 23.3022 43.2658C23.9721 43.2165 24.6394 43.136 25.3018 43.0246C25.3364 43.0188 25.3708 43.0116 25.4054 43.0056C25.9136 42.9108 26.4182 42.7979 26.9183 42.667C27.1788 42.602 27.4403 42.5403 27.6969 42.466C28.1409 42.3342 28.5805 42.1881 29.0151 42.028C29.2547 41.9415 29.4969 41.8603 29.7324 41.7657C30.1529 41.5933 30.5678 41.4077 30.9766 41.2092C31.2142 41.0958 31.4548 40.9881 31.6875 40.8664C32.0662 40.6638 32.4387 40.45 32.8047 40.2253C33.0557 40.0743 33.3116 39.9311 33.5558 39.7704C33.9072 39.533 34.2515 39.2853 34.5884 39.0277C34.8119 38.8611 35.0424 38.7033 35.2591 38.5284C35.5957 38.2506 35.9238 37.9627 36.243 37.6651C36.449 37.4773 36.6623 37.2977 36.8608 37.1023C37.1718 36.7892 37.4731 36.4667 37.7643 36.1353C37.9414 35.9384 38.1277 35.7503 38.2975 35.5471C38.6238 35.1479 38.9358 34.7371 39.2327 34.3156C39.3436 34.1619 39.4665 34.0174 39.5734 33.8607C41.608 30.8745 42.8635 27.4267 43.2254 23.8314C43.2255 23.8307 43.2254 23.83 43.2254 23.8293C43.2254 23.8272 43.2254 23.8251 43.2254 23.823C43.2972 23.1065 43.3332 22.3869 43.3333 21.6669C43.3256 20.6462 43.2457 19.6273 43.0942 18.6179L34.5841 10.1078Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2596 34.3486L19.1485 33.654L20.6195 25.474L13.4375 23.5586L9.3208 28.5129L12.2596 34.3486Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0675 34.5279L18.371 34.0767L20.7662 30.3442L17.4485 26.925L9.93726 31.244L14.0675 34.5279Z",
    fill: "#556B82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91699 27.4221L16.6436 42.7178C17.7582 42.9857 18.8923 43.1647 20.0353 43.2531L11.1592 34.377L8.9904 28.9878L1.91699 27.4221Z",
    fill: "url(#paint4_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7084 7.58353C24.221 7.58353 20.5834 11.2212 20.5834 15.7085C20.5852 15.9268 20.5957 16.1449 20.6151 16.3623C19.218 18.0694 15.4092 22.3716 15.0757 22.7565C12.4576 22.7921 10.1164 24.3952 9.13642 26.8233C7.79587 30.1537 9.40921 33.9403 12.7398 35.2805C16.0702 36.621 19.8568 35.0077 21.197 31.6771C21.4942 30.933 21.6513 30.1403 21.6604 29.3391L28.0482 23.8018C28.2677 23.8213 28.488 23.8319 28.7084 23.8335C33.1957 23.8335 36.8334 20.1958 36.8334 15.7085C36.8334 11.2212 33.1957 7.58353 28.7084 7.58353ZM28.7084 10.8335C31.4007 10.8335 33.5834 13.0161 33.5834 15.7085C33.5834 18.4009 31.4007 20.5835 28.7084 20.5835C26.016 20.5835 23.8334 18.4009 23.8334 15.7085C23.8334 13.0161 26.016 10.8335 28.7084 10.8335ZM15.2175 24.9169C15.755 24.9232 16.2867 25.0293 16.7853 25.23C19.0058 26.1238 20.0811 28.6486 19.1869 30.8689C18.2931 33.0893 15.7683 34.1646 13.548 33.2704C11.3275 32.3766 10.2523 29.8518 11.1465 27.6315C11.8139 25.9738 13.4305 24.8958 15.2175 24.9169Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7082 19.5001C30.8022 19.5001 32.4998 17.8024 32.4998 15.7083C32.4998 13.6143 30.8022 11.9167 28.7082 11.9167C26.6141 11.9167 24.9165 13.6143 24.9165 15.7083C24.9165 17.8024 26.6141 19.5001 28.7082 19.5001Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16154 20.1117C1.11584 20.6289 1.08972 21.1477 1.08325 21.6669C1.08738 23.6151 1.36806 25.5528 1.91691 27.4221L13.9542 32.2653C14.7539 32.5868 15.6485 32.5775 16.4413 32.2394C17.2341 31.9014 17.8601 31.2622 18.1817 30.4626C18.5032 29.6629 18.4939 28.7683 18.1558 27.9755C17.8177 27.1827 17.1786 26.5567 16.379 26.2351L1.16154 20.1117Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24.9853,
    y1: 12.0245,
    x2: 41.1096,
    y2: 25.4437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31363B",
    stopOpacity: 0.208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31363B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 30.2997,
    y1: 14.0833,
    x2: 45.4664,
    y2: 29.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31363B",
    stopOpacity: 0.208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31363B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 34.6667,
    y1: 10.8333,
    x2: 48.75,
    y2: 24.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31363B",
    stopOpacity: 0.208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31363B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 11.6516,
    y1: 25.7413,
    x2: 27.776,
    y2: 39.1605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31363B",
    stopOpacity: 0.208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31363B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 1.86875,
    y1: 27.404,
    x2: 15.9521,
    y2: 41.4873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31363B",
    stopOpacity: 0.208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31363B",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteam);
export default __webpack_public_path__ + "static/media/steam.d7b8819f879421dc2f25a3474964687d.svg";
export { ForwardRef as ReactComponent };